import { useEffect } from "react";

const SITE_URL = "https://mcandido.it";
const DEFAULT_TITLE = "Avvocato del Lavoro Piacenza, Milano, Lecce | Studio Legale Candido";
const DEFAULT_DESCRIPTION = "Studio Legale dell'Avv. Marco Candido, specializzato in diritto del lavoro. Sedi a Piacenza, Milano e Lecce. Operiamo in tutta Italia.";
const DEFAULT_OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/a9778dd3-cc77-4862-94cf-6a30e83d1c8c/images/92649c30fb8195c6e2cf37183ce091f5570bd6f52a7e5b54ec32fe7a1d139edb.png";

export function useSEO({ title, description, path, image }) {
    useEffect(() => {
        const fullTitle = title ? `${title} | Studio Legale Candido` : DEFAULT_TITLE;
        const desc = description || DEFAULT_DESCRIPTION;
        const url = `${SITE_URL}${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;
        const ogImage = image || DEFAULT_OG_IMAGE;

        document.title = fullTitle;

        const setMeta = (selector, attr, value) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                // Parse selector like: meta[property="og:url"] or meta[name="description"]
                const match = selector.match(/\[([^=]+)=["']?([^"'\]]+)["']?\]/);
                if (match) {
                    el.setAttribute(match[1], match[2]);
                }
                document.head.appendChild(el);
            }
            el.setAttribute(attr, value);
        };

        setMeta('meta[name="description"]', "content", desc);

        // Open Graph
        setMeta('meta[property="og:title"]', "content", fullTitle);
        setMeta('meta[property="og:description"]', "content", desc);
        setMeta('meta[property="og:url"]', "content", url);
        setMeta('meta[property="og:type"]', "content", "website");
        setMeta('meta[property="og:image"]', "content", ogImage);
        setMeta('meta[property="og:locale"]', "content", "it_IT");
        setMeta('meta[property="og:site_name"]', "content", "Avv. Marco Candido");

        // Twitter
        setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
        setMeta('meta[name="twitter:title"]', "content", fullTitle);
        setMeta('meta[name="twitter:description"]', "content", desc);
        setMeta('meta[name="twitter:image"]', "content", ogImage);

        // Canonical
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", url);
    }, [title, description, path, image]);
}

/**
 * Inietta dinamicamente uno o più schema JSON-LD nel <head>.
 * @param {Array|Object} schemas - Singolo schema o array di schemi schema.org
 * @param {string} id - ID univoco del tag <script> (per cleanup e replace)
 */
export function useJsonLd(schemas, id = "dynamic-jsonld") {
    useEffect(() => {
        if (!schemas) return undefined;
        const list = Array.isArray(schemas) ? schemas : [schemas];

        // Rimuovi precedente schema con stesso id
        const existing = document.getElementById(id);
        if (existing) existing.remove();

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = id;
        // Schema.org accetta sia singolo oggetto sia array; usiamo array se più di uno
        script.textContent = JSON.stringify(list.length === 1 ? list[0] : list);
        document.head.appendChild(script);

        return () => {
            const el = document.getElementById(id);
            if (el) el.remove();
        };
    }, [JSON.stringify(schemas), id]);
}

export const SITE = { url: SITE_URL };
